<template>
  <Modal v-model="supplyPriorityConfigurationModal" :title="$t('key1007104')" width="750" class-name="commonModalStyles"
    :transfer="false" :mask-closable="false">
    <div slot="header" class="flex align-items-center">
      <h2 class="mr5 font-size-15 font-weight-bold">{{ $t('key1007104') }}</h2>
      <Tooltip :content="$t('key1007105')" max-width="500" placement="top" transfer>
        <Icon color="#2D8CF0" type="md-alert" class="cursor mr3" size="17"/>
      </Tooltip>
    </div>
    <Card :bordered="false" dis-hover v-for="(item, index) in supplyPriorityConfigurationData">
      <template #title>
        <h2 class="title_box">{{ item.name }}</h2>
      </template>
      <div class="table_box">
        <Table
          highlight-row
          :loading="tableLoading"
          border
          max-height="400"
          :columns="tableColumns"
          :data="item.tableData"
          :draggable="draggable"
          @on-drag-drop="(oldIndex, newIndex)=>dragDrop(index, oldIndex, newIndex)">
        </Table>
      </div>
    </Card>
    <template #footer>
      <Button @click="supplyPriorityConfigurationModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" :disabled="supplyPriorityConfigurationData.length <=0" @click="supplyPriorityConfigurationBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {batchAllWarehouseData, getCommonParamKeysData, getSupplierConfigurationItemData,
  getSupplierWarehouseData, saveErpCommonSettingParam, commonLocalStorage} from "@/utils/common";

export default {
  name: 'supplyPriorityConfigurationModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      supplyPriorityConfigurationModal: false,
      supplyPriorityConfigurationData: [],
      tableColumns: [
        {
          title: '',
          key: 'sort',
          align: 'center',
          width: 70,
          renderHeader: (h) => {
            return h('span', '');
          },
          render: (h) => {
            return h('div', {
              class: 'cursor-move',
              on: {
                mousedown() {
                  v.draggable = true;
                }
              }
            }, [
              h('Icon', {
                props: {
                  type: 'md-move',
                  size: 18
                },
                class: 'cursor-move'
              })
            ])
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000241'),
          key: 'warehouseName',
          minWidth: 120,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002585'),
          key: 'deliveryPlaceName',
          minWidth: 140,
          align: 'center'
        },
      ],
      draggable: false,
      paramsKeys: 'goodsCollection',
    }
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
  },
  methods: {
    // 初始化数据
    initSupplyPriorityConfigurationData() {
      this.supplyPriorityConfigurationData = [];
      this.supplyPriorityConfigurationModal = true;
      const info = commonLocalStorage.getItem('supplierConfigurationItemInfo') ?? this.$store.state.supplierConfigurationItemInfo;
      let obj = info?.goodsCollection;
      if (obj) {
        const ymsWarehouseIds = Object.keys(obj);
        const wmsWarehouseIdList = this.uniqueFunc(ymsWarehouseIds.flatMap(id => (obj[id] || []).map(({wmsWarehouseId}) => wmsWarehouseId).filter(Boolean)));
        return Promise.all([
          batchAllWarehouseData(ymsWarehouseIds),
          getSupplierWarehouseData({
            countryCode: null,
            warehouseIds: wmsWarehouseIdList,
            warehouseName: '',
            warehouseStatus: 0,
            ymsDeliveryPlaceId: null,
          })
        ]).then(([arr1 = [], arr2 = []]) => {
          this.supplyPriorityConfigurationData = ymsWarehouseIds.map(id => {
            const warehouse = arr1.find(w => w.ymsWarehouseId === id && w.status === 1);
            if (!warehouse) return null;
            const tableData = (obj[id] || []).map(ele => {
              const matchWarehouse = arr2.find(t => t.warehouseId === ele.wmsWarehouseId && Number(t.warehouseStatus) === 0);
              if (matchWarehouse) {
                return {
                  ...ele,
                  ...matchWarehouse
                };
              }
              return null;
            }).filter(Boolean);
            // 只保留有数据的仓库
            if (tableData.length === 0) return null;
            return {ymsWarehouseId: id, name: warehouse.name, tableData};
          }).filter(Boolean);
        });
      }
    },
    // 拖拽排序
    dragDrop(index, oldIndex, newIndex) {
      let v = this;
      let tableData = v.supplyPriorityConfigurationData[index].tableData;
      tableData[oldIndex] = tableData.splice(newIndex, 1, tableData[oldIndex])[0];
      tableData.map((item, index) => {
        item.sortNo = index + 1;
      });
      v.draggable = false;
      v.$set(v.supplyPriorityConfigurationData[index], 'tableData', tableData);
      v.$forceUpdate();
    },
    // 确定
    supplyPriorityConfigurationBtn() {
      let paramValues = {};
      this.supplyPriorityConfigurationData.map((item) => {
        paramValues[item.ymsWarehouseId] = item.tableData.map((ele) => {
          return {
            wmsWarehouseId: ele.wmsWarehouseId,
            sortNo: ele.sortNo
          }
        })
      });
      let queryList = [
        {
          businessId: this.userInfo.merchantId,
          paramKey: this.paramsKeys,
          paramValue: JSON.stringify(paramValues),
        }
      ];
      saveErpCommonSettingParam(queryList).then(() => {
        this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000708'));
        this.supplyPriorityConfigurationModal = false;
        getSupplierConfigurationItemData(true);
      });
    }
  }
};
</script>

<style lang="less" scoped>
.commonModalStyles /deep/ {
  .ivu-card-head .title_box {
    color: #333;
    font-size: 14px;
    font-weight: bold;
  }
}
</style>
